module.exports = __webpack_public_path__ + "static/media/Documentos.2b035d0e.svg";